<template>
  <section
    class="feedback-welcome feedback__step uk-cover-container uk-flex uk-flex-middle"
  >
    <picture>
      <source
        srcset="@/assets/images/start.webp"
        media="(min-width: 960px)"
      />
      <source
        srcset="@/assets/images/start@tab.webp"
        media="(min-width: 640px)"
      />
      <source srcset="@/assets/images/start@mob.webp" />
      <img
        alt="powitania tło"
        src="@/assets/images/start.webp"
        class="about-team__image"
        data-uk-cover
      />
    </picture>
    <div class="uk-container">
      <div class="feedback-welcome__content">
        <h2 class="feedback-welcome__header">
          współpraca z Solveit<br>- obsługa klienta
        </h2>
        <span class="feedback-welcome__goodmorning">Dzień dobry!</span>
        <p class="feedback-welcome__description">
          Dziękujemy za skorzystanie z naszej oferty. Wraz z zakończeniem współpracy, zwracamy się do Państwa z prośbą o wypełnienie krótkiej ankiety podsumowującej nasze działanie. Wypełniona ankieta pozwoli nam doskonalić usługi naszej firmy. Wypełnienie jej zajmuje kilka minut.
        </p>

        <button
          class="button button--arrow button--shadow"
          @click="$emit('increment-step')"
        >
          start
        </button>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Welcome',
};
</script>
<style scoped lang="scss">
.feedback-welcome {
  background-color: $purpleDim;
  color: $white;
  position: relative;
  min-height: 100vh;
  width: 100%;

  &__header {
    font-size: 1.75rem;
    font-weight: 900;
    margin-bottom: rem(40px);

    @include media-min($lg) {
      font-size: 2.5rem;
      margin-bottom: rem(48px);
    }
  }

  &__description {
    font-size: 1.25rem;
    font-weight: 400;
    margin-bottom: rem(40px);
    max-width: rem(500px);
  }

  &__goodmorning {
    font-size: 1.25rem;
    font-weight: 700;
    color: $teal;
    display: block;
    margin-bottom: rem(20px);
  }

  &__content {
    @include media-min($lg) {
      transform: translateY(rem(-70px));
    }
  }

  .uk-container {
    position: relative;
    z-index: 10;
    width: 100%;
    max-width: rem(800px);
  }
}
</style>
